import React from "react";
import { ArrowBackCircle } from 'react-ionicons'
import DatePicker from "react-datepicker";
import HCPs from "./HCPs"
import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "@popperjs/core"
import { Modal } from 'react-bootstrap';
import { v4 as uuidv4 } from 'uuid';
import constantURI from "../URI"
import _post from "../Functions/Post"
import stylesMed from "./stylesMed"
import SearchFilterFunction from "../Functions/SearchFilter"
import Authenticate from "../Functions/MedRepAuthenticate"

export default class AddActivity extends React.Component {

    constructor() {
        super();
        this.state = {
            cost: "", name: "", purpose: "", targetAudience: "", attendees: "", location: "", comment: [], qty: [], selectedType: "", area: "",
            assets: [], sample: [], todaysDate: "", todaysTime: "", show: true, fromDate: "", toDate: "", Date: new Date(),
            mainIndex: 0, showAssets: false, showAttendees: false, showClients: false, index: -1, clients: [], loading: true, areas: [], type: [],
            activityCount: 0, activityUpdateCount: 0, USActivities: [], USActivities2: [], UUID: [], UUID2: [], USActivitiesAssets: [], USActivitiesAssets2: [],
            logistics: [], USActivitiesLogist: [], USActivitiesLogist2: [], isCompleted: false, isCompleted2: 0, ActivityID: 0, Activity: [], USUActivities: [],
            USUActivities2: [], UUIDUpdate: [], UUIDUpdate2: [], USUActivitiesAssets: [], USUActivitiesAssets2: [], USUActivitiesLogist: [], USUActivitiesLogist2: [],
            offline: false, showAlert: false, assetIndex: 0, disableSave: false, disableSync: false, preventSymbols: ["e", "E", "+", "-", "."],
            requiredFields: { fromDate: false, toDate: false, cost: false, type: false, name: false, speaker: false, area: false }, showRequiredAlert: false,
            alertString: "", clientsCopy: [], user: "", supervisors: [], showAlertBack: false, userDetail: [], token: "", authenticate: false, AssetItems: [],
            loadingUpdate: false, alertUndefined: false
        }
    }

    async componentDidMount() {
        this.setState({ todaysDate: this.state.Date.toISOString().substring(0, 10), todaysTime: this.state.Date.toISOString().substring(11, 19) });
        const HCP = localStorage.getItem('ActivityID');
        if (HCP !== "0" && HCP !== null) {
            this.setState({ loadingUpdate: true })
        }
        await Authenticate().then((response) => { this.setState({ authenticate: response }) });
        const activityCount = localStorage.getItem('UnsyncedActivitiesCount');
        const usAct = localStorage.getItem('UnsyncedActivities');
        const usActLogist = localStorage.getItem('UnsyncedActivitiesLogistics');
        const uuid = localStorage.getItem('UUIDAct');
        const user = localStorage.getItem('User');
        const token = localStorage.getItem('Token');
        await this.setState({
            loading: false, activityCount: JSON.parse(activityCount), USActivities: JSON.parse(usAct),
            UUID: JSON.parse(uuid), USActivitiesLogist: JSON.parse(usActLogist), user: JSON.parse(user), token: JSON.parse(token)
        });

        const readURL = constantURI() + "odooController/MedRepRead";
        const clientsBody = {
            jsonrpc: "2.0",
            params: {
                method: "search_read",
                model: "res.partner",
                args: [],
                kwargs: {
                    fields: ["name", "street", "phone", "potential", "state_id", "x_specialty_id", "clienttype", "x_month_visits"],
                    domain: [["x_repuser", "=", this.state.user]]
                }
            },
            "token": this.state.token
        }
        const repSupervisor = {
            "jsonrpc": "2.0",
            "params": {
                "method": "search_read",
                "model": "res.users",
                "args": [],
                "kwargs": {
                    "fields": ["name", "supervisor"],
                    "domain": [["name", "=", this.state.user]]
                }
            },
            "token": this.state.token
        }
        const rep = {
            "jsonrpc": "2.0",
            "params": {
                "method": "search_read",
                "model": "res.partner",
                "args": [],
                "kwargs": {
                    "fields": ["name"],
                    "domain": [["name", "=", this.state.user]]
                }
            },
            "token": this.state.token
        }
        if (this.state.authenticate) {
            await _post(readURL, repSupervisor).then((response) => {
                return response.json().then(async (data) => {
                    if (data.result !== undefined) {
                        this.setState({ supervisors: data.result[0].supervisor })
                        localStorage.setItem('Supervisor', JSON.stringify(this.state.supervisors));
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
            await _post(readURL, rep).then((response) => {
                return response.json().then(async (data) => {
                    if (data.result !== undefined) {
                        this.setState({ userDetail: data.result })
                        localStorage.setItem('UserDetail', JSON.stringify(this.state.userDetail));
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
            await _post(readURL, clientsBody).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({ clients: data.result, clientsCopy: data.result })
                        localStorage.setItem('HCPs', JSON.stringify(this.state.clients));
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
        }
        else {
            const supervisors = localStorage.getItem('Supervisor');
            const userDetail = localStorage.getItem('UserDetail');
            const clients = localStorage.getItem('HCPs');
            await this.setState({
                supervisors: JSON.parse(supervisors), userDetail: JSON.parse(userDetail), clients: JSON.parse(clients),
                clientsCopy: JSON.parse(clients)
            });
        }

        const tempClients = this.state.clients;
        const supervisor = {};
        supervisor.id = this.state.supervisors[0];
        supervisor.name = this.state.supervisors[1];
        await tempClients.push(supervisor);
        await tempClients.push(this.state.userDetail[0]);
        await this.setState({ clients: tempClients, clientsCopy: tempClients });

        if (HCP !== "0" && HCP !== null) {
            await this.setState({ ActivityID: HCP, loadingUpdate: true });
            const activityBody = {
                "jsonrpc": "2.0",
                "params": {
                    "method": "search_read",
                    "model": "event.event",
                    "args": [],
                    "kwargs": {
                        "fields": ["name", "date_begin", "date_end", "x_country_state_id", "x_externallocation", "x_speakpartner_id",
                            "targetaudience", "att_exp_count", "x_repuserid", "x_eventtype", "x_modetype", "x_topic", "x_status", "registration_ids",
                            "x_asset_ids"],
                        "domain": [["id", "=", this.state.ActivityID]]
                    }
                },
                "token": this.state.token
            }
            if (this.state.authenticate) {
                await _post(readURL, activityBody).then((response) => {
                    return response.json().then(async (data) => {
                        if (data.result !== undefined) {
                            await this.setState({ Activity: data.result });
                        }
                        else {
                            this.setState({ alertUndefined: true });
                        }
                    })
                })
            }
            else {
                alert("No Internet connectivity! Update when re-connected.");
                await this.setState({ offline: true });
                this.props.history.push("/DailySchedule");
            }
            if (!this.state.offline) {
                await this.setState({
                    name: this.state.Activity[0].name, area: this.state.Activity[0].x_country_state_id[0],
                    location: this.state.Activity[0].x_externallocation, targetAudience: this.state.Activity[0].targetaudience,
                    attendees: this.state.Activity[0].att_exp_count, selectedType: this.state.Activity[0].x_eventtype[0],
                    cost: this.state.Activity[0].x_modetype, purpose: this.state.Activity[0].x_topic, isCompleted2: this.state.Activity[0].x_status,
                    fromDate: new Date(this.state.Activity[0].date_begin), toDate: new Date(this.state.Activity[0].date_end),
                    ...this.state.requiredFields.fromDate = true, ...this.state.requiredFields.toDate = true, ...this.state.requiredFields.cost = true,
                    ...this.state.requiredFields.type = true, ...this.state.requiredFields.name = true, ...this.state.requiredFields.speaker = true,
                    ...this.state.requiredFields.area = true, loadingUpdate: false
                })
                if (this.state.isCompleted2 === 1) {
                    await this.setState({ isCompleted: true });
                }
                await this.state.clients.map((item, index) => {
                    if (item.id === this.state.Activity[0].x_speakpartner_id[0]) {
                        this.setState({ index: index });
                    }
                })
            }
        }

        const areaBody = {
            "jsonrpc": "2.0",
            "params": {
                "method": "search_read",
                "model": "res.country.state",
                "args": [],
                "kwargs": {
                    "fields": ["name"]
                }
            },
            "token": this.state.token
        }
        const typeBody = {
            "jsonrpc": "2.0",
            "params": {
                "method": "search_read",
                "model": "x_event.type",
                "args": [],
                "kwargs": {
                    "fields": ["x_name"]
                }
            },
            "token": this.state.token
        }
        const currentRep = {
            "jsonrpc": "2.0",
            "params": {
                "method": "search_read",
                "model": "res.partner",
                "args": [],
                "kwargs": {
                    "fields": ["name"],
                    "domain": [["name", "=", this.state.user]]
                }
            },
            "token": this.state.token
        }
        if (this.state.authenticate) {
            await _post(readURL, areaBody).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({ areas: data.result })
                        localStorage.setItem('Area', JSON.stringify(this.state.areas));
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })

            await _post(readURL, typeBody).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({ type: data.result })
                        localStorage.setItem('MeetingType', JSON.stringify(this.state.type));
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
            await _post(readURL, currentRep).then((response) => {
                return response.json().then(async (data) => {
                    if (data.result !== undefined) {
                        this.setState({ currentRep: data.result })
                        localStorage.setItem('UserDetail', JSON.stringify(this.state.currentRep));
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
        }
        else {
            const currentRep = localStorage.getItem("UserDetail");
            const area = localStorage.getItem('Area');
            const type = localStorage.getItem('MeetingType');
            this.setState({ areas: JSON.parse(area), currentRep: JSON.parse(currentRep), type: JSON.parse(type) });
        }
    }

    onSearch = async (text) => {
        var values = await SearchFilterFunction(text, this.state.clients, this.state.clientsCopy, this.state.noData);
        this.setState({ clients: values.items, noData: values.noData })
    }

    onChangeSelectedType = async (e) => {
        await this.setState({ selectedType: e.target.value });
        if (e.target.value === "")
            this.setState({ ...this.state.requiredFields.type = false })
        else
            this.setState({ ...this.state.requiredFields.type = true })
    }

    onChangeArea = async (e) => {
        await this.setState({ area: e.target.value })
        if (e.target.value === "")
            this.setState({ ...this.state.requiredFields.area = false })
        else
            this.setState({ ...this.state.requiredFields.area = true })
    }

    onChangeAsset = (e) => {
        this.setState({ ...this.state.AssetItems[this.state.mainIndex] = {} })
        this.setState({ ...this.state.AssetItems[this.state.mainIndex].asset = e.target.value })
    }

    onChangeSample = (e) => {
        this.setState({ ...this.state.AssetItems[this.state.mainIndex].sample = e.target.value })
    }

    onChangeCost = async (e) => {
        await this.setState({ cost: e.target.value });
        if (e.target.value === "")
            this.setState({ ...this.state.requiredFields.cost = false })
        else
            this.setState({ ...this.state.requiredFields.cost = true })
    }

    onSelectFromDate = async (date) => {
        await this.setState({ fromDate: date })
        if (date === "")
            this.setState({ ...this.state.requiredFields.fromDate = false })
        else
            this.setState({ ...this.state.requiredFields.fromDate = true })
    }

    onSelectToDate = async (date) => {
        await this.setState({ toDate: date })
        if (date === "")
            this.setState({ ...this.state.requiredFields.toDate = false })
        else
            this.setState({ ...this.state.requiredFields.toDate = true })
    }

    onSelectClient = async (id) => {
        await this.setState({ clients: this.state.clientsCopy });
        await this.state.clientsCopy.map(async (item, index) => {
            if (id === item.id)
                await this.setState({ index: index, getButton: false });
        })
        if (this.state.index === "-1")
            await this.setState({ ...this.state.requiredFields.speaker = false })
        else
            await this.setState({ ...this.state.requiredFields.speaker = true });
        this.closeClients();
    }

    onChangeName = async (e) => {
        await this.setState({ name: e.target.value })
        if (e.target.value === "")
            this.setState({ ...this.state.requiredFields.name = false });
        else
            this.setState({ ...this.state.requiredFields.name = true });
    }

    onChangePurpose = (e) => {
        this.setState({ purpose: e.target.value })
    }

    onChangeAudience = (e) => {
        this.setState({ targetAudience: e.target.value })
    }

    onChangeAttendees = (e) => {
        this.setState({ attendees: e.target.value })
    }

    onChangeLocation = (e) => {
        this.setState({ location: e.target.value })
    }

    onChangeComment = (e) => {
        this.setState({ ...this.state.AssetItems[this.state.mainIndex].comment = e.target.value })
    }

    onChangeQty = (e) => {
        this.setState({ ...this.state.AssetItems[this.state.mainIndex].qty = e.target.value })
    }

    onCompleted = async () => {
        if (!this.state.isCompleted)
            alert("Activity is Completed. If you save you can not access it any more!");

        await this.setState({ isCompleted: !this.state.isCompleted });

        if (this.state.isCompleted) {
            this.setState({ isCompleted2: 1 })
        }
        else {
            this.setState({ isCompleted2: 0 });
        }
    }

    closeClients = () => {
        this.setState({ showClients: false });
    }

    showClients = () => {
        this.setState({ showClients: true, index: -1 });
    }

    onAddAssetBool = () => {
        this.setState({ showAssets: true, show: false });
    }

    showAttendees = () => {
        this.setState(s => ({ showAttendees: true }));
    }

    onAddAsset = () => {
        if (this.state.showAssets) {
            this.setState({ mainIndex: this.state.mainIndex + 1 });
        }
        this.state.qty.length = this.state.mainIndex + 1;
        this.setState(s => ({ showAssets: !s.showAssets }));
    }

    onDeleteItem = (index) => {
        var asset = this.state.AssetItems;
        asset.splice(index, 1);
        this.setState({ AssetItems: asset });
    }

    closeAlertDelete = () => {
        this.setState({ showAlert: false });
    }

    showAlertDelete = (assetIndex) => {
        this.setState({ showAlert: true, assetIndex: assetIndex });
    }

    onSync = async () => {
        await this.setState({ disableSync: true });
        await Authenticate().then((response) => { this.setState({ authenticate: response }) });

        const acts = localStorage.getItem('UnsyncedActivities');
        const assets = localStorage.getItem('UnsyncedActivitiesAssets');
        const uuid = localStorage.getItem('UUIDAct');
        const logis = localStorage.getItem('UnsyncedActivitiesLogistics');
        await this.setState({
            USActivities2: JSON.parse(acts), USActivitiesAssets2: JSON.parse(assets), UUID2: JSON.parse(uuid),
            USActivitiesLogist2: JSON.parse(logis)
        });

        const createActivityURL = constantURI() + "OdooController/CreateActivity"
        const createAssetURL = constantURI() + "OdooController/CreateActivityAsset"
        const createLogisticsURL = constantURI() + "OdooController/CreateActivityLogistics"

        this.state.USActivities2.map(async (act, actIndex, actArr) => {
            if (this.state.authenticate) {
                await _post(createActivityURL, act).then(async (response) => {
                    return response.json().then(async (data) => {
                        if (data.result !== undefined) {
                            if (this.state.USActivitiesAssets2 !== null) {
                                this.state.USActivitiesAssets2.map(async (asset, assetIndex, assetArr) => {
                                    if (asset.params.args[0].x_event_id === this.state.UUID2[actIndex]) {
                                        await this.setState({ ...this.state.USActivitiesAssets2[assetIndex].params.args[0].x_event_id = data.result })
                                        await _post(createAssetURL, this.state.USActivitiesAssets2[assetIndex]).then(() => {
                                            if (this.state.USActivitiesLogist2 !== null && actIndex === actArr.length - 1 && assetIndex === assetArr.length - 1) {
                                                localStorage.setItem('UnsyncedActivitiesCount', JSON.stringify(0));
                                                localStorage.setItem('UnsyncedActivities', JSON.stringify([]));
                                                localStorage.setItem('UUIDAct', JSON.stringify([]));
                                                localStorage.setItem('UnsyncedActivitiesAssets', JSON.stringify([]));
                                                localStorage.setItem('UnsyncedActivitiesLogistics', JSON.stringify([]));
                                                alert("Synced Successfully");
                                                this.props.history.push("./LandingPageRep");
                                            }
                                        })
                                    }
                                })
                            }
                            if (this.state.USActivitiesLogist2 !== null) {
                                this.state.USActivitiesLogist2.map(async (logis, logisIndex, logisArr) => {
                                    if (logis !== null && logis.params.args[0].event_id === this.state.UUID2[actIndex]) {
                                        await this.setState({ ...this.state.USActivitiesLogist2[logisIndex].params.args[0].event_id = data.result })
                                        await _post(createLogisticsURL, this.state.USActivitiesLogist2[logisIndex]).then(() => {
                                            if (actIndex === actArr.length - 1 && logisIndex === logisArr.length - 1) {
                                                localStorage.setItem('UnsyncedActivitiesCount', JSON.stringify(0));
                                                localStorage.setItem('UnsyncedActivities', JSON.stringify([]));
                                                localStorage.setItem('UUIDAct', JSON.stringify([]));
                                                localStorage.setItem('UnsyncedActivitiesAssets', JSON.stringify([]));
                                                localStorage.setItem('UnsyncedActivitiesLogistics', JSON.stringify([]));
                                                alert("Synced Successfully");
                                                this.props.history.push("./LandingPageRep");
                                            }
                                        })
                                    }
                                })
                            }
                            if (this.state.USActivitiesLogist2.length === 0 && this.state.USActivitiesAssets2.length === 0) {
                                if (actIndex === actArr.length - 1) {
                                    localStorage.setItem('UnsyncedActivitiesCount', JSON.stringify(0));
                                    localStorage.setItem('UnsyncedActivities', JSON.stringify([]));
                                    localStorage.setItem('UUIDAct', JSON.stringify([]));
                                    localStorage.setItem('UnsyncedActivitiesAssets', JSON.stringify([]));
                                    localStorage.setItem('UnsyncedActivitiesLogistics', JSON.stringify([]));
                                    alert("Synced Successfully");
                                    this.props.history.push("./LandingPageRep");
                                }
                            }
                        }
                        else {
                            this.setState({ alertUndefined: true });
                        }
                    })
                })
            }
            else if (!this.state.authenticate && actIndex === actArr.length - 1) {
                alert("Only sync when connected to the Internet!");
                await this.setState({ disableSync: false });
            }
        })
    }

    onSave = async () => {
        await this.setState({ disableSave: true });
        await Authenticate().then((response) => { this.setState({ authenticate: response }) });
        var toFill = false;
        var alertString = "";
        Object.keys(this.state.requiredFields).map(async (item, index) => {
            if (!this.state.requiredFields[item]) {
                toFill = true;
                alertString += item + ", ";
                await this.setState({ alertString: alertString });
            }
        })

        if (toFill === true) {
            this.setState({ disableSave: false, showRequiredAlert: true });
        }
        else {
            await this.setState({ disableSave: true, showRequiredAlert: false });

            const createActivityURL = constantURI() + "OdooController/CreateActivity"
            const createAssetURL = constantURI() + "OdooController/CreateActivityAsset"
            const createLogisticsURL = constantURI() + "OdooController/CreateActivityLogistics"
            const updateActivityURL = constantURI() + "OdooController/UpdateActivity"

            if (this.state.ActivityID === 0) {
                var acts = (this.state.USActivities === null || this.state.USActivities === []) ? [] : this.state.USActivities;
                var uuid = (this.state.UUID === null || this.state.UUID === []) ? [] : this.state.UUID;
                var assets = (this.state.USActivitiesAssets === null || this.state.USActivitiesAssets === []) ? [] : this.state.USActivitiesAssets;
                var logis = (this.state.USActivitiesLogist === null || this.state.USActivitiesLogist === []) ? [] : this.state.USActivitiesLogist;
                const logist = localStorage.getItem("ActivityLogistics");
                await this.setState({ logistics: JSON.parse(logist) });

                const tempFromDate = new Date();
                await tempFromDate.setDate(this.state.fromDate.getDate());
                const tempToDate = new Date();
                await tempToDate.setDate(this.state.toDate.getDate());

                const ActivityBody = {
                    "jsonrpc": "2.0",
                    "params": {
                        "method": "create",
                        "model": "event.event",
                        "args": [
                            {
                                "name": this.state.name,
                                "date_begin": tempFromDate.toISOString().substring(0, 10),
                                "date_end": tempToDate.toISOString().substring(0, 10),
                                "x_country_state_id": this.state.area,
                                "x_externallocation": this.state.location,
                                "x_speakpartner_id": this.state.clientsCopy[this.state.index].id,
                                "targetaudience": this.state.targetAudience,
                                "att_exp_count": this.state.attendees,
                                "x_repuserid": this.state.currentRep[0].id,
                                "x_eventtype": this.state.selectedType,
                                "x_modetype": this.state.cost,
                                "x_topic": this.state.purpose,
                                "x_status": this.state.isCompleted2
                            }
                        ],
                        "kwargs": {}
                    },
                    "token": this.state.token
                }
                if (this.state.authenticate) {
                    await _post(createActivityURL, ActivityBody).then(async (response) => {
                        return response.json().then(async (data) => {
                            if (data.result !== undefined) {
                                await this.state.logistics.map(async (item2, index2, arr2) => {
                                    if (item2 !== null) {
                                        await this.state.clients.map(async (client, clientIndex) => {
                                            if (index2 === client.id) {
                                                var LogisticsBody = {
                                                    "jsonrpc": "2.0",
                                                    "params": {
                                                        "method": "create",
                                                        "model": "event.registration",
                                                        "args": [{
                                                            "partner_id": this.state.clientsCopy[clientIndex].id,
                                                            "event_id": data.result,
                                                            "x_memo": item2
                                                        }],
                                                        "kwargs": {
                                                        }
                                                    },
                                                    "token": this.state.token
                                                }
                                                await _post(createLogisticsURL, LogisticsBody).then(async () => {
                                                    if (this.state.AssetItems.length === 0 && index2 === arr2.length - 1) {
                                                        await localStorage.setItem('UnsyncedActivitiesAssets', JSON.stringify([]));
                                                        await localStorage.setItem('UnsyncedActivities', JSON.stringify([]));
                                                        await localStorage.setItem('UnsyncedActivitiesCount', JSON.stringify(0));
                                                        await localStorage.setItem('ActivityLogistics', JSON.stringify([]));
                                                        this.props.history.push("./LandingPageRep");
                                                    }
                                                })
                                            }
                                        })
                                    }
                                })
                                await this.state.AssetItems.forEach(async (item, index, arr) => {
                                    var assetsBody = {
                                        jsonrpc: "2.0",
                                        params: {
                                            method: "create",
                                            model: "x_activityasset",
                                            args: [
                                                {
                                                    "x_event_id": data.result,
                                                    "x_comment": item.comment,
                                                    "x_type": item.asset,
                                                    "x_qty": item.qty
                                                }
                                            ],
                                            "kwargs": {}
                                        },
                                        "token": this.state.token
                                    }
                                    await _post(createAssetURL, assetsBody).then(async () => {
                                        await localStorage.setItem('UnsyncedActivitiesAssets', JSON.stringify([]));
                                        await localStorage.setItem('UnsyncedActivities', JSON.stringify([]));
                                        await localStorage.setItem('UnsyncedActivitiesCount', JSON.stringify(0));
                                        await localStorage.setItem('ActivityLogistics', JSON.stringify([]));
                                        this.props.history.push("./LandingPageRep");
                                    })
                                })
                                if (this.state.AssetItems.length === 0 && this.state.logistics.length === 0) {
                                    await localStorage.setItem('UnsyncedActivitiesAssets', JSON.stringify([]));
                                    await localStorage.setItem('UnsyncedActivities', JSON.stringify([]));
                                    await localStorage.setItem('UnsyncedActivitiesCount', JSON.stringify(0));
                                    await localStorage.setItem('ActivityLogistics', JSON.stringify([]));
                                    this.props.history.push("./LandingPageRep");
                                }
                            }
                            else {
                                this.setState({ alertUndefined: true });
                            }
                        })
                    })
                }
                else {
                    await acts.push(ActivityBody);
                    await this.setState({ activityCount: this.state.activityCount + 1 });
                    await localStorage.setItem('UnsyncedActivities', JSON.stringify(acts));
                    await localStorage.setItem('UnsyncedActivitiesCount', JSON.stringify(this.state.activityCount));

                    var test = uuidv4();
                    await uuid.push(test);
                    localStorage.setItem('UUIDAct', JSON.stringify(uuid));

                    await this.state.logistics.map(async (item2, index2, arr2) => {
                        if (item2 !== null) {
                            var LogisticsBody = {
                                "jsonrpc": "2.0",
                                "params": {
                                    "method": "create",
                                    "model": "event.registration",
                                    "args": [{
                                        "partner_id": this.state.clientsCopy[index2].id,
                                        "event_id": test,
                                        "x_memo": item2
                                    }],
                                    "kwargs": {
                                    }
                                },
                                "token": this.state.token
                            }
                            await logis.push(LogisticsBody);
                            if (this.state.AssetItems.length === 0 && index2 === arr2.length - 1) {
                                await localStorage.setItem('UnsyncedActivitiesAssets', JSON.stringify(assets));
                                await localStorage.setItem('UnsyncedActivitiesLogistics', JSON.stringify(logis));
                                await alert("This activity is not uploaded to Odoo due to internet disconnection. Sync when reconnected.")
                                this.props.history.push("./LandingPageRep");
                            }
                        }
                    })
                    await this.state.AssetItems.forEach(async (item, index, arr) => {
                        var assetsBody = {
                            jsonrpc: "2.0",
                            params: {
                                method: "create",
                                model: "x_activityasset",
                                args: [
                                    {
                                        "x_event_id": test,
                                        "x_comment": item.comment,
                                        "x_type": item.asset,
                                        "x_qty": item.qty
                                    }
                                ],
                                "kwargs": {}
                            },
                            "token": this.state.token
                        }
                        await assets.push(assetsBody);
                        if (index === arr.length - 1) {
                            await localStorage.setItem('UnsyncedActivitiesAssets', JSON.stringify(assets));
                            await localStorage.setItem('UnsyncedActivitiesLogistics', JSON.stringify(logis));
                            await alert("This activity is not uploaded to Odoo due to internet disconnection. Sync when reconnected.")
                            this.props.history.push("./LandingPageRep");
                        }
                    })
                    if (this.state.AssetItems.length === 0 && this.state.logistics.length === 0) {
                        await alert("This activity is not uploaded to Odoo due to internet disconnection. Sync when reconnected.")
                        this.props.history.push("./LandingPageRep");
                    }
                }
            }
            else {
                var actsUpdate = (this.state.USUActivities === null || this.state.USUActivities === []) ? [] : this.state.USUActivities;
                var uuidUpdate = (this.state.UUIDUpdate === null || this.state.UUIDUpdate === []) ? [] : this.state.UUIDUpdate;
                var assetsUpdate = (this.state.USUActivitiesAssets === null || this.state.USUActivitiesAssets === []) ? [] : this.state.USUActivitiesAssets;
                var logisUpdate = (this.state.USUActivitiesLogist === null || this.state.USUActivitiesLogist === []) ? [] : this.state.USUActivitiesLogist;
                const logist = localStorage.getItem("ActivityLogistics");
                await this.setState({ logistics: JSON.parse(logist) });

                const tempFromDate = new Date();
                await tempFromDate.setDate(this.state.fromDate.getDate());
                const tempToDate = new Date();
                await tempToDate.setDate(this.state.toDate.getDate());

                var updateActivityBody = {
                    "jsonrpc": "2.0",
                    "params": {
                        "method": "write",
                        "model": "event.event",
                        "args": [[Number(this.state.ActivityID)],
                        {
                            "name": this.state.name,
                            "date_begin": tempFromDate.toISOString().substring(0, 10),
                            "date_end": tempToDate.toISOString().substring(0, 10),
                            "x_country_state_id": this.state.area,
                            "x_externallocation": this.state.location,
                            "x_speakpartner_id": this.state.clientsCopy[this.state.index].id,
                            "targetaudience": this.state.targetAudience,
                            "att_exp_count": this.state.attendees,
                            "x_repuserid": this.state.currentRep[0].id,
                            "x_eventtype": this.state.selectedType,
                            "x_modetype": this.state.cost,
                            "x_topic": this.state.purpose,
                            "x_status": this.state.isCompleted2
                        }
                        ],
                        "kwargs": {}
                    },
                    "token": this.state.token
                }
                if (this.state.authenticate) {
                    await _post(updateActivityURL, updateActivityBody).then((response) => {
                        return response.json().then(async (data) => {
                            await this.state.logistics.map(async (item2, index2, arr2) => {
                                if (item2 !== null) {
                                    console.log(this.state.clientsCopy[index2]);
                                    console.log(this.state.clientsCopy);
                                    var updateLogisticsBody = {
                                        "jsonrpc": "2.0",
                                        "params": {
                                            "method": "create",
                                            "model": "event.registration",
                                            "args": [{
                                                "partner_id": this.state.clientsCopy[index2].id,
                                                "event_id": this.state.ActivityID,
                                                "x_memo": item2
                                            }],
                                            "kwargs": {
                                            }
                                        },
                                        "token": this.state.token
                                    }
                                    await _post(createLogisticsURL, updateLogisticsBody).then(async () => {
                                        if (this.state.AssetItems.length === 0 && index2 === arr2.length - 1) {
                                            await localStorage.setItem('UnsyncedActivitiesAssets', JSON.stringify([]));
                                            await localStorage.setItem('UnsyncedActivities', JSON.stringify([]));
                                            await localStorage.setItem('UnsyncedActivitiesCount', JSON.stringify(0));
                                            await localStorage.setItem('ActivityLogistics', JSON.stringify([]));
                                            await localStorage.setItem("ActivityID", JSON.stringify(0));
                                            this.props.history.push("./LandingPageRep");
                                        }
                                    })
                                }
                            })
                            await this.state.AssetItems.forEach(async (item, index, arr) => {
                                var updateAssetsBody = {
                                    jsonrpc: "2.0",
                                    params: {
                                        method: "create",
                                        model: "x_activityasset",
                                        args: [
                                            {
                                                "x_event_id": this.state.ActivityID,
                                                "x_comment": item.comment,
                                                "x_type": item.asset,
                                                "x_qty": item.qty
                                            }
                                        ],
                                        "kwargs": {}
                                    },
                                    "token": this.state.token
                                }
                                await _post(createAssetURL, updateAssetsBody).then(async () => {
                                    await localStorage.setItem('UnsyncedActivitiesAssets', JSON.stringify([]));
                                    await localStorage.setItem('UnsyncedActivities', JSON.stringify([]));
                                    await localStorage.setItem('UnsyncedActivitiesCount', JSON.stringify(0));
                                    await localStorage.setItem('ActivityLogistics', JSON.stringify([]));
                                    await localStorage.setItem("ActivityID", JSON.stringify(0));
                                    this.props.history.push("./LandingPageRep");
                                })
                            })
                            if (this.state.AssetItems.length === 0 && this.state.logistics.length === 0) {
                                await localStorage.setItem('UnsyncedActivitiesAssets', JSON.stringify([]));
                                await localStorage.setItem('UnsyncedActivities', JSON.stringify([]));
                                await localStorage.setItem('UnsyncedActivitiesCount', JSON.stringify(0));
                                await localStorage.setItem('ActivityLogistics', JSON.stringify([]));
                                await localStorage.setItem("ActivityID", JSON.stringify(0));
                                this.props.history.push("./LandingPageRep");
                            }

                        })
                    })
                }
                else {
                    await actsUpdate.push(updateActivityBody);
                    await this.setState({ activityUpdateCount: this.state.activityUpdateCount + 1 });
                    await localStorage.setItem('UnsyncedActivities2', JSON.stringify(actsUpdate));
                    await localStorage.setItem('UnsyncedActivitiesCount2', JSON.stringify(this.state.activityUpdateCount));

                    var test = uuidv4();
                    await uuidUpdate.push(test);
                    localStorage.setItem('UUIDAct2', JSON.stringify(uuidUpdate));

                    await this.state.logistics.map(async (item2, index2, arr2) => {
                        if (item2 !== null) {
                            var updateLogisticsBody = {
                                "jsonrpc": "2.0",
                                "params": {
                                    "method": "create",
                                    "model": "event.registration",
                                    "args": [{
                                        "partner_id": this.state.clientsCopy[index2].id,
                                        "event_id": test,
                                        "x_memo": item2
                                    }],
                                    "kwargs": {
                                    }
                                },
                                "token": this.state.token
                            }
                            await logisUpdate.push(updateLogisticsBody);
                            if (this.state.AssetItems.length === 0 && index2 === arr2.length - 1) {
                                await localStorage.setItem('UnsyncedActivitiesAssets2', JSON.stringify(assetsUpdate));
                                await localStorage.setItem('UnsyncedActivitiesLogistics2', JSON.stringify(logisUpdate));
                                await alert("This activity is not uploaded to Odoo due to internet disconnection. Sync when reconnected.")
                                this.props.history.push("./LandingPageRep");
                            }
                        }
                    })
                    await this.state.AssetItems.forEach(async (item, index, arr) => {
                        var updateAssetsBody = {
                            jsonrpc: "2.0",
                            params: {
                                method: "create",
                                model: "x_activityasset",
                                args: [
                                    {
                                        "x_event_id": test,
                                        "x_comment": item.comment,
                                        "x_type": item.asset,
                                        "x_qty": item.qty
                                    }
                                ],
                                "kwargs": {}
                            },
                            "token": this.state.token
                        }
                        await assetsUpdate.push(updateAssetsBody);
                        if (index === arr.length - 1) {
                            await localStorage.setItem('UnsyncedActivitiesAssets2', JSON.stringify(assetsUpdate));
                            await localStorage.setItem('UnsyncedActivitiesLogistics2', JSON.stringify(logisUpdate));
                            await alert("This activity is not uploaded to Odoo due to internet disconnection. Sync when reconnected.")
                            this.props.history.push("./LandingPageRep");
                        }
                    })
                    if (this.state.AssetItems.length === 0 && this.state.logistics.length === 0) {
                        this.props.history.push("./LandingPageRep");
                    }
                }
            }
        }
    }

    closeAlertBack = () => {
        this.setState({ showAlertBack: false });
    }

    showAlertBack = () => {
        this.setState({ showAlertBack: true });
    }

    render() {
        if (!this.state.loadingUpdate) {
            return (
                <div className="container-fluid position-absolute" style={stylesMed.mainBackgroundColor}>
                    {(this.state.activityCount === 0 || this.state.activityCount === null) ?
                        <div className="alert alert-secondary">You have 0 planned visits to sync with Odoo.</div> :
                        <div className="col alert alert-danger">You have {this.state.activityCount} unsynced activities to sync with Odoo.
                          <div className="row">
                                <h5 className="col-sm-8">Only sync when connected to the Internet!</h5>
                                <div className="col-sm-4 d-flex flex-row-reverse">
                                    <div className={(this.state.disableSync) ? "btn disabled" : "btn"} style={stylesMed.wideButton} onClick={this.onSync}>
                                        Sync Planned Visits</div>
                                </div>
                            </div>
                        </div>
                    }
                    {(!this.state.showRequiredAlert) ?
                        null :
                        <div className="col alert alert-danger">{this.state.alertString} are required fields that should be filled.</div>
                    }
                    {(!this.state.alertUndefined) ?
                        null :
                        <div className="col alert alert-danger">
                            <div className="row">
                                <h6 className="col-sm-8">There seems to be a problem.</h6>
                                <div className="col d-flex flex-row-reverse">
                                    <div className={(this.state.disableSync) ? "btn disabled" : "btn"} style={stylesMed.wideButton} onClick={() => window.location.reload()}>
                                        Reload</div>
                                </div>
                            </div>
                        </div>
                    }
                    <div className="row pt-3">
                        <div className="col">
                            <ArrowBackCircle className="btn" onClick={() => this.showAlertBack()}
                                color={'#00bfff'}
                                height="50px"
                                width="50px"
                            />
                        </div>
                        <div className="col text-center"><h5 style={stylesMed.activityTitle}>Activity</h5></div>
                        <div className="col d-flex flex-row-reverse">
                            <div className={(this.state.disableSave) ? "btn disabled" : "btn"} style={stylesMed.wideButton} onClick={this.onSave}>Save Activity</div>
                        </div>
                    </div>
                    <Modal show={this.state.showAlertBack} onHide={this.closeAlertBack} animation={false}>
                        <Modal.Header>
                            <Modal.Title>Save changes?</Modal.Title>
                        </Modal.Header>
                        <Modal.Footer>
                            <div className="btn" data-toggle="modal" data-target="#myModal" style={stylesMed.wideButton} onClick={this.onSave}>Save</div>
                            <div className="btn btn-secondary" data-toggle="modal" data-target="#myModal" style={stylesMed.cancelWideButton}
                                onClick={async () => { this.props.history.push("./LandingPageRep"); await localStorage.setItem("ActivityID", JSON.stringify(0)); }}>Discard</div>
                        </Modal.Footer>
                    </Modal>
                    <div className="mt-4 p-3" style={stylesMed.cardBackgroundColor}>
                        <div className="row mt-1 form-group">
                            <p className="col-sm-6 d-flex align-items-center">Creation Date*:
                                    {(this.state.ActivityID === 0) ? " " + new Date(this.state.todaysDate).toDateString() + " " + this.state.todaysTime :
                                    ((this.state.Activity.length === 0) ?
                                        null : this.state.Activity[0].date_begin)}
                            </p>
                        </div>
                        <div className="row mt-1">
                            <div className="col">
                                <p style={stylesMed.clientDetail}>From Date*: </p>
                                <DatePicker selected={this.state.fromDate} onChange={(date) => this.onSelectFromDate(date)}
                                    className={(this.state.showRequiredAlert && !this.state.requiredFields.fromDate) ? "border border-danger" : null} />
                            </div>
                            <div className="col">
                                <p style={stylesMed.clientDetail}>To Date*: </p>
                                <DatePicker selected={this.state.toDate} className={(this.state.showRequiredAlert && !this.state.requiredFields.toDate) ?
                                    "border border-danger" : null} onChange={(date) => this.onSelectToDate(date)} />
                            </div>
                        </div>
                        <div className="row mt-1 form-group">
                            <div className="col">
                                <label className=" d-flex align-items-center">Activity Type*:</label>
                                <select className=" form-control" id="sel1" value={this.state.selectedType}
                                    onChange={this.onChangeSelectedType} name="sellist1" style={(this.state.showRequiredAlert && !this.state.requiredFields.type) ?
                                        stylesMed.activityTypeInputRequired : stylesMed.activityTypeInput}>
                                    <option value=""></option>
                                    {this.state.type.map((item, index) => {
                                        return (
                                            <option key={index} value={item.id}>{item.x_name}</option>
                                        )
                                    })}
                                </select>
                            </div>
                            <div className="col">
                                <label className="d-flex align-items-center">Activity Cost*:</label>
                                <input className="form-control" type="number"
                                    onKeyDown={e => this.state.preventSymbols.includes(e.key) && e.preventDefault()} min="1"
                                    value={this.state.cost}
                                    onChange={this.onChangeCost} style={(this.state.showRequiredAlert && !this.state.requiredFields.cost) ?
                                        stylesMed.activityCostInputRequired : stylesMed.activityCostInput} />
                            </div>
                        </div>
                        <div className="mt-2">
                            <label>Activity Name*:</label>
                            <input className="form-control" style={(this.state.showRequiredAlert && !this.state.requiredFields.name) ? stylesMed.activityNameRequired : null}
                                value={this.state.name} onChange={this.onChangeName} />
                        </div>
                        <div className="mt-2">
                            <label>Activity Purpose:</label>
                            <textarea className="form-control" value={this.state.purpose} onChange={this.onChangePurpose} style={stylesMed.activitypurposeInput} />
                        </div>
                        <div className="d-flex justify-content-center mt-3">
                            <div className="btn" style={(this.state.isCompleted) ? stylesMed.activityCompleted : stylesMed.activityNotCompleted}
                                onClick={this.onCompleted}>Completed</div>
                        </div>
                    </div>


                    <div className="mt-4 p-3" style={stylesMed.cardBackgroundColor}>
                        <div className="row mt-2">
                            <div className="col">
                                <label className="d-flex align-items-center">Select Speaker*:</label>
                                <input className="form-control"
                                    defaultValue={(this.state.loading || this.state.index === -1 || this.state.index === "-1") ? "" :
                                        this.state.clients[this.state.index].name}
                                    onClick={this.showClients} style={(this.state.showRequiredAlert && !this.state.requiredFields.speaker) ?
                                        stylesMed.activityCostInputRequired : stylesMed.activityCostInput} />
                            </div>
                            <div className="col">
                                <label className="d-flex align-items-center">Target Audience:</label>
                                <textarea className="form-control" value={this.state.targetAudience} onChange={this.onChangeAudience}
                                    style={stylesMed.activityCostInput} />
                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <label className="d-flex align-items-center">Expected Attendees #:</label>
                                <input className="form-control" type="number"
                                    onKeyDown={e => this.state.preventSymbols.includes(e.key) && e.preventDefault()} min="1"
                                    value={this.state.attendees}
                                    onChange={this.onChangeAttendees}
                                    style={stylesMed.activityCostInput} />
                            </div>
                            <div className="col">
                                <label className="col-sm-4 d-flex align-items-center">Area*:</label>
                                <select className="col-sm-8 form-control" id="sel1" value={this.state.area} onChange={this.onChangeArea} name="sellist1"
                                    style={(this.state.showRequiredAlert && !this.state.requiredFields.area) ? stylesMed.activityCostInputRequired : stylesMed.activityCostInput}>
                                    <option value=""></option>
                                    {this.state.areas.map((item, index) => {
                                        return (
                                            <option key={index} value={item.id}>{item.name}</option>
                                        )
                                    })}
                                </select>
                            </div>
                        </div>
                        <div className="mt-2">
                            <label className="d-flex align-items-center">Location:</label>
                            <textarea className="form-control" value={this.state.location} onChange={this.onChangeLocation} style={stylesMed.activityCostInput} />
                        </div>
                    </div>
                    <Modal show={this.state.showClients} onHide={this.closeClients} animation={false}>
                        <Modal.Header>
                            <Modal.Title>Select Client</Modal.Title>
                        </Modal.Header>
                        <Modal.Body><div>
                            <input type="text" className="form-control" placeholder="Search Here" onChange={text => this.onSearch(text)} />
                            {this.state.clients.map((item, index) => {
                                return (
                                    <div className="pt-3" key={index}>
                                        <div className="btn" onClick={() => this.onSelectClient(item.id)} >{item.name}</div>
                                    </div>
                                )
                            })}
                        </div></Modal.Body>
                    </Modal>

                    <div className="mt-4 p-4" style={stylesMed.cardBackgroundColor}>
                        <h3>Assets</h3>
                        {
                            (this.state.show) ?
                                <div className="d-flex justify-content-center mt-3">
                                    <div className="btn" style={stylesMed.wideButton} onClick={this.onAddAssetBool}>Add Asset</div>
                                </div> :
                                (this.state.showAssets) ?
                                    <div>
                                        {this.state.AssetItems.map((item, index, arr) => {
                                            if (index !== arr.length - 1) {
                                                return (
                                                    <div className="row m-1" key={index}>
                                                        <div className="col mt-1">
                                                            <div className="btn" style={stylesMed.deleteButton} onClick={() => this.showAlertDelete(index)}>Delete</div>
                                                        </div>
                                                        <h6 className="col d-flex justify-content-center mt-1">{item.asset}</h6>
                                                        <h6 className="col d-flex justify-content-center mt-1">{(item.asset !== "Samples") ? item.comment : item.sample}</h6>
                                                        <h6 className="col d-flex justify-content-center mt-1">{item.qty}</h6>
                                                    </div>
                                                )
                                            }
                                            else return null
                                        })}
                                        <div className="row m-2">
                                            <select className="col form-control" id="sel1" value={this.state.assets[this.state.mainIndex]}
                                                onChange={this.onChangeAsset} name="sellist1" >
                                                <option value="">Asset</option>
                                                <option value="Rollups">Rollups</option>
                                                <option value="Stands">Stands</option>
                                                <option value="Printing">Printing Materials</option>
                                                <option value="Gadgets">Gadgets</option>
                                                <option value="Samples">Samples</option>
                                                <option value="Other">Other</option>
                                            </select>
                                            <div className="col">
                                                {(this.state.AssetItems[this.state.mainIndex] !== undefined && this.state.AssetItems[this.state.mainIndex].asset !== "Samples") ?
                                                    <input className="form-control"
                                                        value={this.state.comment[this.state.mainIndex]}
                                                        onChange={this.onChangeComment} />
                                                    :
                                                    <select className="form-control"
                                                        value={this.state.sample[this.state.mainIndex]}
                                                        onChange={this.onChangeSample} >
                                                        <option value=""></option>
                                                    </select>
                                                }
                                            </div>
                                            <input className="col form-control" placeholder="Quantity" type="number"
                                                onKeyDown={e => this.state.preventSymbols.includes(e.key) && e.preventDefault()} min="1"
                                                value={this.state.qty[this.state.mainIndex]}
                                                onChange={this.onChangeQty} />
                                        </div>
                                    </div> :
                                    this.state.AssetItems.map((item, index, arr) => {
                                        return (
                                            <div className="row m-1" key={index}>
                                                <div className="col mt-1">
                                                    <div className="btn" style={stylesMed.deleteButton} onClick={() => this.showAlertDelete(index)}>Delete</div>
                                                </div>
                                                <h6 className="col d-flex justify-content-center mt-1">{item.asset}</h6>
                                                <h6 className="col d-flex justify-content-center mt-1">{(item.asset !== "Samples") ? item.comment : item.sample}</h6>
                                                <h6 className="col d-flex justify-content-center mt-1">{item.qty}</h6>
                                            </div>
                                        )
                                    })
                        }

                        {(!this.state.showAssets) ?
                            
                            (!this.state.show) ? <div className="d-flex justify-content-center mt-3">
                                <div className="btn" style={stylesMed.wideButton} onClick={this.onAddAsset}>Add Asset</div>
                            </div> : null
                         :
                            <div className="d-flex justify-content-center mt-2">
                                <div className="btn" style={stylesMed.wideButton} onClick={this.onAddAsset}>Save Asset</div>
                            </div>
                        }
                       
                    </div>


                    <div className="d-flex justify-content-center mt-4">
                        <div className="btn" style={(this.state.showAttendees) ? stylesMed.activityShow : stylesMed.activityHide} onClick={this.showAttendees}>
                            Attendees
                    </div>
                    </div>
                    {
                        (this.state.showAttendees) ?
                            <HCPs show={true}></HCPs>
                            : null
                    }
                    <Modal show={this.state.showAlert} onHide={this.closeAlertDelete} animation={false}>
                        <Modal.Header>
                            <Modal.Title>Are you sure you want to delete this item?</Modal.Title>
                        </Modal.Header>
                        <Modal.Body><div>
                            <div className="btn" style={stylesMed.deleteButtonAlert}
                                onClick={() => { this.onDeleteItem(this.state.assetIndex); this.closeAlertDelete() }}>Delete</div>
                            <div className="btn btn-secondary" style={stylesMed.cancelButtonAlert}
                                onClick={() => this.closeAlertDelete()}>Cancel</div>
                        </div></Modal.Body>
                    </Modal>
                </div >
            );
        }
        else {
            return (
                <div className="vh-100" style={stylesMed.mainBackgroundColor}>
                    <div className="pt-3 text-center">
                        <div className="spinner-border" style={stylesMed.spinner}></div>
                    </div>
                </div>
            )
        }
    }
}
